// Internalizado de @mandae/ng-api 2.13.7 na remoção da dependência.
// Mantidos apenas os métodos usados pelo webapp.
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIConfig } from '../api-config';
import { ClienteResponse, CustomerCommercial } from '../models/customer';

@Injectable({
  providedIn: 'root'
})
export class CustomerApiService {
  constructor(private http: HttpClient, private config: APIConfig) { }

  /**
   * Busca cliente por id
   */
  public getCustomerById(id: number): Observable<ClienteResponse> {
    return this.http.get<ClienteResponse>(`${this.config.customerApiUrl}/clientes/${id}`);
  }

  /**
   * Obtém os dados comerciais de um cliente
   *
   * @param id ID do cliente para obter os dados comerciais
   */
  public getCustomerCommercialData(id: number): Observable<CustomerCommercial> {
    return this.http.get<CustomerCommercial>(`${this.config.customerApiUrl}/clientes/${id}/comercial`);
  }

  /**
   * Obtém o arquivo da fatura atrelada ao usuário logado
   *
   * @param invoiceId ID da fatura
   * @param format formato da fatura: [pdf, csv]
   */
  public getUserInvoiceFile(invoiceId: number, format: string): Observable<HttpResponse<ArrayBuffer>> {
    return this.http.get(
      `${this.config.customerApiUrl}/v1/faturas/${invoiceId}/arquivos/${format}`, {
        responseType: 'arraybuffer',
        observe: 'response'
      });
  }
}
